<template>
  <div id="app">
    <!--TopNavigation/-->
    <router-view></router-view>

    <div id="background-img"><img height="75px" src="@/assets/images/echo-logo-white.jpg"></div>
  </div>
</template>

<script>
//import TopNavigation from './components/TopNavigation.vue'
import Axios from 'axios'  
import { AmplifyEventBus } from 'aws-amplify-vue'
import { Auth } from 'aws-amplify'

export default {
  name: 'app',
  components: {
  //  TopNavigation
  },
  data() {
    return {
      // signedIn: false
    }
  },
  beforeCreate() {
    AmplifyEventBus.$on('authState', user => {
      if (user && user!=undefined) {
        this.$store.dispatch('authstore/setUser', user)
        // console.log("navigating to /")
        this.$router.push('/home')
      } else {
        // console.log("authstore/setUser to null")
        this.$store.dispatch('authstore/setUser', null)
        // localStorage.clear()

        // console.log("navigating to /auth")
        this.$router.push('/auth')
      }
    })
    
    Auth.currentAuthenticatedUser()
    .then(user => {
      this.$store.dispatch('authstore/setUser', user)
    })
    .catch(() => {
      this.$store.dispatch('authstore/setUser', null)
    })
  },
  created() {
    // https://blog.sqreen.com/authentication-best-practices-vue/
    // Axios.interceptors.response.use( function (response) {
    //   // alert("intercepting response")
    //       return response;
    //   }, function (err) {      
    //   alert("intercepting response")
    //   return new Promise(function (resolve, reject) {
    //     if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
    //       // if you ever get an unauthorized, logout the user
    //       //this.$store.dispatch(AUTH_LOGOUT)
    //       // you can also redirect to /login if needed !
    //       alert("Error: Unauthorized. Standby to be redirected to login page.")
    //       this.signOut()
    //     }
    //     console.log("need to log user out here or redirect to login or use refresh token")
    //     console.log(err)
    //     alert(err)
    //   })
    // })

    // Axios.interceptors.request.use(function(request) {
    //   alert("intercepting request")
    //   return request
    // })
  },
  methods:{
    async signOut() {
      Auth.signOut()
      .then(user => {
          // this.activeApp='Echo Ops Portal Home'
          AmplifyEventBus.$emit('authState', user)
      })
      .catch(err => alert(err.message))
    },
  }
}
</script>



<style>

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 80px;
}

#background-img{
  position: fixed;
  text-align:right;
  /* right: 0px;*/
  bottom: 0px; 
  width:100%;
  height:75px;
} 
</style>
